import { ChefHat } from 'lucide-react';
import { cn } from '~/common/utils/styleUtil';
import { TooltipButton } from '~/common/components/TooltipButton';
import { useTranslation } from 'react-i18next';

export interface SalesOrderSetInfoProps {
  className?: string;
}

export function SalesOrderSetInfo({ className }: Readonly<SalesOrderSetInfoProps>) {
  const { t } = useTranslation();

  return (
    //eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={cn('', className)}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      data-testid={'salesorderset-info'}
    >
      <TooltipButton
        text={t('Bereits gekaufter Artikel')}
        icon={<ChefHat size={20} className={'text-secondary'} />}
        className={'mx-0'}
      />
    </div>
  );
}
